import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import BaseTag from '@deprecated-ui/common/Tag';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  effects as companyEffects,
  selectors as companySelector,
} from 'lib/entities/company';
import { Input, SearchContainer, Label, InputContainer } from './styled';

const { Tag } = BaseTag;

interface TargetPriceSearchProps {
  symbol: string;
  onChangeSymbol: (val: any) => any;
}

function TargetPriceSearch({ symbol, onChangeSymbol }: TargetPriceSearchProps) {
  const [timeInterval, setTimeInterval] = useState(0);

  const dispatch = useDispatch();

  // selectors
  const {
    search: { data: dataSearch },
  } = useSelector(companySelector);

  const handleSearch = (val) => {
    // dispatch redux search company disini

    if (val.length > 1) {
      if (timeInterval) {
        clearTimeout(timeInterval);
      }

      setTimeInterval(
        window.setTimeout(() => {
          dispatch(companyEffects.getSearchCompany(val));
        }, 1000),
      );
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    const data = {
      target_symbol: String(value).toUpperCase(),
    };
    onChangeSymbol(data);
  };

  const handleSelectCompany = (val) => {
    // dispatch redux select target symbol disini
    const data = {
      target_symbol: val,
    };
    onChangeSymbol(data);
  };

  const options = dataSearch.map(({ name, desc }) => ({
    value: name,
    label: (
      <Flex align="center">
        <Tag size="s" type="grey">
          {name}
        </Tag>
        {/* @ts-expect-error */}
        <Text ml="10px" size="13px" ellipsis>
          {desc}
        </Text>
      </Flex>
    ),
  }));
  return (
    <InputContainer>
      <Label>My Target Price For</Label>
      <SearchContainer
        options={options}
        getPopupContainer={(trigger) => trigger.parentElement}
        onSearch={handleSearch}
        onSelect={handleSelectCompany}
        value={symbol}
      >
        <Input placeholder="Stock Symbol" onChange={handleChange} />
      </SearchContainer>
    </InputContainer>
  );
}

export default TargetPriceSearch;
